"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSbAccess = fetchSbAccess;
exports.linkOwnGithubAccount = linkOwnGithubAccount;
exports.useSbAccess = useSbAccess;
const react_1 = require("react");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
async function fetchSbAccess() {
    try {
        const response = await fetch(`${MainSetupReact_1.default.serverUrl}sbAccess/access`, { credentials: "include" });
        if (response.status === 401 || response.status === 403)
            return { canManage: false, canSeeSb: false, sb: null };
        if (!response.ok)
            return "error";
        return await response.json();
    }
    catch {
        return "error";
    }
}
async function linkOwnGithubAccount(login) {
    try {
        const response = await fetch(`${MainSetupReact_1.default.serverUrl}sbAccess/me/githubAccount`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ githubLogin: login }),
        });
        if (!response.ok) {
            let message = "";
            try {
                const body = await response.json();
                if (typeof body?.errorMessage === "string")
                    message = body.errorMessage;
            }
            catch { /* Odpowiedź bez JSON zachowuje kod błędu. */ }
            return { ok: false, status: response.status, message };
        }
        const body = await response.json();
        return { ok: true, result: body.result, note: body.note };
    }
    catch {
        return { ok: false, status: 0, message: "" };
    }
}
function useSbAccess(enabled = true) {
    const [view, setView] = (0, react_1.useState)({ state: enabled ? "loading" : "denied", access: null });
    const [revision, setRevision] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (!enabled) {
            setView({ state: "denied", access: null });
            return;
        }
        let active = true;
        setView({ state: "loading", access: null });
        fetchSbAccess().then(access => {
            if (!active)
                return;
            setView(access === "error"
                ? { state: "error", access: null }
                : { state: access.canSeeSb && access.sb ? "granted" : "denied", access });
        });
        return () => { active = false; };
    }, [enabled, revision]);
    return {
        ...(enabled ? view : { state: "denied", access: null }),
        reload: () => setRevision(value => value + 1),
    };
}
